import { Suspense } from "react";
import { LoaderComponent } from "./PrivateRoute";

const withSuspense = (Component) => (
  <Suspense fallback={<LoaderComponent />}>
    <Component />
  </Suspense>
);

export default withSuspense;